export const INSTANT_LUCKY_DRAW = "instantLuckyDraw"